import { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";

const BASE_DESCRIPTION =
  "Independent property consultant throughout Lincolnshire — Lincoln, Grantham, Sleaford, Boston, Skegness, Spalding & more. EPCs, landlord inspections, snagging, condition surveys, roof surveys & more.";

function setMeta(name, content, isProperty = false) {
  const attr = isProperty ? "property" : "name";
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function SiteLayout({ children, pageTitle, pageDescription, pagePath = "/" }) {
  useEffect(() => {
    const fullTitle = pageTitle
      ? `${pageTitle} · Declan Bishop — Property Consultant`
      : "Declan Bishop — Property Consultant | PE & LN";
    document.title = fullTitle;

    const desc = pageDescription || BASE_DESCRIPTION;
    setMeta("description", desc);
    setMeta("og:title", fullTitle, true);
    setMeta("og:description", desc, true);
    setMeta("og:url", `https://dbpropertyconsultant.co.uk${pagePath}`, true);
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
    setCanonical(`https://dbpropertyconsultant.co.uk${pagePath}`);

    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pageTitle, pageDescription, pagePath]);

  return (
    <div className="min-h-screen flex flex-col bg-brand-cream text-brand-navy">
      <Navbar />
      <main className="flex-1 pt-28 md:pt-36">{children}</main>
      <Footer />
    </div>
  );
}
